import { APIRequest } from "../lib/_sso";
import AppConfig from "../_appConfig";

const server = AppConfig.api_server;

export default {
  list: () => APIRequest.get(`${server}/rotas`).then((res) => res.data),
  add: (data) => APIRequest.post(`${server}/rotas`, data).then((res) => res.data),
  update: (id, data) => APIRequest.patch(`${server}/rotas/${id}`, data).then((res) => res.data),
  delete: (id) => APIRequest.delete(`${server}/rotas/${id}`).then((res) => res.data),

  // dutyRotas: () => APIRequest.get(`${server}/rotas/duty`).then((res) => res.data),
  // currentDutyRota: (rota_id) => APIRequest.get(`${server}/rotas/duty/current/${rota_id}`).then((res) => res.data),

  getMonthData: (month, year) => APIRequest.get(`${server}/rotas/month_data/${month}/${year}`).then((res) => res.data),

  scheduleMonthView: (rotaId, month, year) => APIRequest.get(`${server}/rotas/${rotaId}/month_schedule/${month}/${year}`).then((res) => res.data),
  assignShift: (rotaId, data) => APIRequest.post(`${server}/rotas/${rotaId}/schedule/assign`, data).then((res) => res.data),
  unassignShift: (rotaId, data) => APIRequest.patch(`${server}/rotas/${rotaId}/schedule/unassign`, data).then((res) => res.data),
}